<section class="container mt-3 mb-3">
    <div class="row">
        <div class="col-12 login contenederoLogin">
            <!-- Botón cerrar -->
            <mat-icon class="float-right rounded pb-2 pl-3 pr-3 botonesCerrar" 
                      [mat-dialog-close]="!mostrarVerificacion ? true : null"
                      (click)="mostrarVerificacion ? cerrarVerificacion() : null"> 
                cancel_presentation
            </mat-icon>
            
            <div class="fondoBlanco rounded shadow-lg">
                
                <!-- ========== SECCIÓN LOGIN ========== -->
                <ng-container *ngIf="!mostrarVerificacion">
                    <div class="pl-4 pr-4 pt-4">
                        <h2 class="colorLetras tamanoTitulo"><strong>Iniciar Sesión</strong></h2>
                        <h5 class="azul"><strong>Tu Perfil All Tickets</strong></h5>
                    </div>
             
                    <form class="padding margenResponsive">
                        
                        <!-- Input Correo -->
                        <div class="mt-3 form-group margenResponsive">
                            <input type="text" 
                                   name="username" 
                                   class="rounded form-control formCorreo"  
                                   placeholder="Correo" 
                                   [(ngModel)]="usuario.correo">
                            <small class="colorLetras">
                                Ingresa con tu correo registrado en All Tickets
                            </small>
                        </div>

                        <!-- Input Contraseña (solo si correoPass es true) -->
                        <div class="mt-3 form-group margenResponsive position-relative" *ngIf="correoPass">
                            <input [type]="mostrarPassword ? 'text' : 'password'" 
                                   name="password" 
                                   class="rounded form-control formCorreo pr-5" 
                                   placeholder="Contraseña" 
                                   [(ngModel)]="usuario.contrasena">

                            <span class="position-absolute end-0 top-50 translate-middle-y me-3"
                                  style="cursor: pointer"
                                  (click)="togglePassword()">
                                <i [ngClass]="mostrarPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                            </span>
                        </div>
                    
                        <!-- Botón Submit y Mensajes de Error -->
                        <div class="mt-3 mb-3 margenResponsive">
                            <small *ngIf='invalidLogin' class="text-danger">{{errorMessage}}</small>
                            <br *ngIf='invalidLogin'>
                            
                            <button
                                class="btn botonLogin mt-3 iniciar centrar-flex"
                                type="button"
                                (click)="correoPass ? handleLogin() : handleLogin2()"
                            >
                                Iniciar sesión
                            </button>

                            <button
                                class="btn botonLoginNoPass mt-3 iniciar centrar-flex"
                                type="button"
                                (click)="cambiarInicio()"
                            >
                                Iniciar sesión {{ correoPass ? 'sin' : 'con' }} contraseña
                            </button>
                            
                        </div>

                        <!-- Link olvidó contraseña -->
                        <div class="centrarTexto" *ngIf="correoPass">
                            <a class="colorLetras" (click)="olvidoContrasenia()">
                                ¿Olvidaste tu contraseña?
                            </a>

                            
                        </div>

                    </form>
                
                    <br>

                    <button class="btn botonCrearCuenta mb-3" 
                            (click)="openDialog()" 
                            type="button">
                        Crear cuenta nueva
                    </button>

                    <br>
                    
                    <button class="btn botonCrearCuentaGoogle mb-3" 
                            (click)="loginWithGoogle()" 
                            type="button">
                        <svg class="me-2" width="20" height="20" viewBox="0 0 24 24">
                            <path fill="#4285f4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                            <path fill="#34a853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                            <path fill="#fbbc05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                            <path fill="#ea4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                        </svg>
                        Continuar con Google
                    </button>
                </ng-container>

                <!-- ========== SECCIÓN VERIFICACIÓN ========== -->
                <ng-container *ngIf="mostrarVerificacion">
                    <div class="pl-4 pr-4 pt-4 text-center">
                        <h2 class="tamanoTitulo" style="color: #FF8C42;">
                            <strong>Verifica tu correo</strong>
                        </h2>
                    </div>
             
                    <form (ngSubmit)="verificarCodigo()" class="padding margenResponsive">
                        <div class="mt-3 form-group margenResponsive text-center">
                            <p>Ingresa el código de 4 dígitos enviado a {{ correoUsuario }}</p>
                            
                            <!-- Inputs para el código -->
                            <div class="d-flex justify-content-center mt-4 mb-4">
                                <div class="codigo-input-wrapper mx-2" *ngFor="let num of [1,2,3,4]">
                                    <input type="text" 
                                        [attr.id]="'input' + num"
                                        maxlength="1" 
                                        class="codigo-input" 
                                        [(ngModel)]="this['digito' + num]" 
                                        [name]="'digito' + num" 
                                        (keydown)="onKeyDown($event, num)"
                                        (input)="onInputChange($event, num)"
                                        (paste)="manejarPegado($event)">
                                </div>
                            </div>

                            <small style="color: #ed701c;">
                                ¿No recibiste el código? 
                                <strong *ngIf="!puedeReenviar">Podrás reenviar en {{ tiempoRestante }}s</strong>
                                <strong *ngIf="puedeReenviar">Ya puedes reenviar</strong>
                            </small>
                        </div>
                    
                        <div class="mt-3 mb-3 margenResponsive">
                            <button class="btn w-100 mt-3" 
                                    style="background-color: #ed701c; color: white;" 
                                    type="submit">
                                Verificar código
                            </button>
                            
                            <button class="btn w-100 mt-2 mb-2" 
                                    style="color: white;"
                                    [style.background-color]="puedeReenviar ? 'rgba(16, 36, 56, 1)' : 'rgba(16, 36, 56, 0.3)'"
                                    [disabled]="!puedeReenviar"
                                    type="button"
                                    (click)="reenviarCodigo()">
                                Reenviar código
                            </button>
                        </div>
                    </form>
                </ng-container>

            </div>
        </div>
    </div>
</section>